<div class="page-content page-fill">
    <div class="grid-fill">
        <dx-data-grid
            #categoryGrid
            [dataSource]="people"
            keyExpr="id"
            [showBorders]="true"
            [rowAlternationEnabled]="false"
            [focusedRowEnabled]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
        >
            <dxi-column dataField="firstName"></dxi-column>
            <dxi-column dataField="lastName"></dxi-column>
            <dxi-column dataField="email"></dxi-column>
            <dxi-column dataField="cellPhone"></dxi-column>
            <dxi-column dataField="family_HomePhone" caption="Home Phone"></dxi-column>
            <dxi-column dataField="interestsLastUpdated" caption="Last Updated" [dataType]="'date'"></dxi-column>

            <dxo-selection mode="multiple"></dxo-selection>
            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [fileName]="selectedInterest?.name" [allowExportSelectedData]="true"></dxo-export>

            <div *dxTemplate="let data of 'toolbarButtons'" class="d-flex align-items-center">
                <div class="d-inline-block me-2 text-bold">Interest</div>
                <dx-select-box
                    [(value)]="selectedInterest"
                    [placeholder]="'select interest'"
                    [dataSource]="interests"
                    displayExpr="name"
                    class="flex-fill"
                    (onValueChanged)="selectedInterestChanged($event)"
                    [visible]="interests"
                    style="width: 500px;"
                ></dx-select-box>
            </div>
        </dx-data-grid>
    </div>
</div>
